import React, { useCallback } from "react";
import Button from "@material-ui/core/Button";
import { uniq } from "lodash";
import type { FC } from "react";
import { useStyles } from "./Actions.styles";
import { Hierarchy } from "../../../../../../../../common";
import type { IActionsProps } from "./Actions.types";

export const Actions: FC<IActionsProps> = (props) => {
  const classes = useStyles();
  const { selectedIds, hierarchies, candidateHierarchies, selectedHierarchies, onChange } = props;

  const handleAddAllToRight = useCallback(() => {
    const allHierarchiesIds = Hierarchy.ultimateHierarchies(hierarchies).map((c) => c.id);
    onChange?.(allHierarchiesIds);
  }, [onChange, hierarchies]);

  const handleAddToRight = useCallback(() => {
    const selectedHierarchiesIds = Hierarchy.ultimateHierarchies(selectedHierarchies).map((c) => c.id);
    const allHierarchies = Hierarchy.flat(hierarchies);
    const candidatesHierarchies = allHierarchies.filter((h) => selectedIds.includes(h.id) && h.children.length === 0);
    const candidatesHierarchiesIds = candidatesHierarchies.map((h) => h.id);
    const selection = uniq([...selectedHierarchiesIds, ...candidatesHierarchiesIds]);
    
    onChange?.(selection);
  }, [onChange, selectedIds, selectedHierarchies]);

  const handleRemoveToLeft = useCallback(() => {
    const selectedHierarchiesIds = Hierarchy.ultimateHierarchies(selectedHierarchies).map((c) => c.id);
    const selection = uniq(selectedHierarchiesIds.filter((x) => !selectedIds.includes(x)));
    onChange?.(selection);
  }, [onChange, selectedIds, selectedHierarchies]);

  const handleRemoveAllToLeft = useCallback(() => {
    onChange?.([]);
  }, [onChange, hierarchies]);

  const disabledAddToRight = Hierarchy.flat(candidateHierarchies).every((it) => !selectedIds.includes(it.id));
  const disabledRemoveToLeft = Hierarchy.flat(selectedHierarchies).every((it) => !selectedIds.includes(it.id));

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        className={classes.button}
        onClick={handleAddAllToRight}
        disabled={candidateHierarchies.length === 0}
        aria-label="move all right"
      >
        &gt;&gt;
      </Button>
      <Button
        variant="outlined"
        size="small"
        className={classes.button}
        onClick={handleAddToRight}
        disabled={disabledAddToRight}
        aria-label="move selected right"
      >
        &gt;
      </Button>
      <Button
        variant="outlined"
        size="small"
        className={classes.button}
        onClick={handleRemoveToLeft}
        disabled={disabledRemoveToLeft}
        aria-label="move selected left"
      >
        &lt;
      </Button>
      <Button
        variant="outlined"
        size="small"
        className={classes.button}
        onClick={handleRemoveAllToLeft}
        disabled={selectedHierarchies.length === 0}
        aria-label="move all left"
      >
        &lt;&lt;
      </Button>
    </>
  );
};
